module.exports = __webpack_public_path__ + "21535d28d8a0e7cf56bddfedbbd1b32b.png";